export const reportSubstitutionSettlementsTypes = {
  SET_SUBSTITUTION_SETTLEMENTS_FILTERS: 'SET_SUBSTITUTION_SETTLEMENTS_FILTERS',
  RESTORE_INITIAL: 'REPORT_SUBSTITUTION_SETTLEMENTS/RESTORE_INITIAL'
};
